var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContainer"},[_c('NavBar'),_c('router-view',{staticClass:"sideContainer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }